/**
 * ContactDetailRedirect.js
 *
 * Post-unification redirect: the old /crm/:id route was deprecated when
 * contacts were merged into businesses (migration 001). The :id used to be a
 * contact id; after migration it's either a business id (orphan contacts
 * were promoted) or a business id linked from a former contact.
 *
 * We simply redirect to /business/:id. If the id does not resolve to a
 * business, the BusinessDetail page surfaces its own "not found" state.
 */
import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function ContactDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={`/business/${id}`} replace />;
}
